export default __webpack_public_path__ + "static/media/DisablePayments.fb507075.svg";